<template>
    <auth-layout>
        <Head>
            <title>Passwort vergessen</title>
        </Head>

        <div class="auth-form">
            <div class="auth-form--form">
                <h3>
                    <h3 v-translate>Passwort vergessen?</h3>
                </h3>
                <p class="body-1">
                    <translate render-html="true">Wir haben Ihnen eine Email zum zurücksetzen Ihres Passwortes zugesendet.</translate>
                </p>
            </div>
            <div class="auth-form--info">
                <p class="body-2 body-2--disabled">
                    <translate>Als geprüfter Produzent können Sie sich mit den von uns übermittelten Anmeldedaten schnell und einfach anmelden.</translate>
                </p>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@partfactory/Layouts/AuthLayout';

export default {
    name: 'ForgotPasswordConfirmation',
    components: {
        AuthLayout,
    },
};
</script>
